import Dashboard from "@/pages/Auth/Dashboard.vue";

export default {
  // Navbar (موجودة مسبقاً إن رغبت)
  home: "الرئيسية",
  services: "خدماتنا",
  support: "المساندة",
  about: "من نحن",
  login: "تسجيل دخول",
  signup: "إنشاء حساب",
  login_title: "تسجيل الدخول",
  login_subtitle: "أدخل بياناتك للوصول إلى حسابك",
  login_method_label: "طريقة تسجيل الدخول",
  login_tab_mobile: "برقم الجوال",
  login_tab_email: "بالبريد الإلكتروني",
  login_mobile_label: "رقم الجوال",
  login_mobile_placeholder: "05XXXXXXXX",
  login_email_label: "البريد الإلكتروني",
  login_email_placeholder: "name@example.com",
  login_password_label: "الرقم السري",
  login_password_placeholder: "••••••••",
  login_remember_me: "تذكرني",
  login_forgot_password: "نسيت الرقم السري؟",
  login_submit: "دخول",
  login_loading: "جاري التحقق…",
  login_no_account: "ليس لديك حساب؟",
  login_create_account: "أنشئ حسابًا الآن",
  login_error_phone_required: "الرجاء إدخال رقم الجوال.",
  login_error_email_required: "الرجاء إدخال البريد الإلكتروني.",
  login_error_phone_invalid: "صيغة رقم الجوال غير صحيحة.",
  login_error_email_invalid: "صيغة البريد غير صحيحة.",
  login_error_password_required: "الرجاء إدخال الرقم السري.",
  login_error_validation: "تحقق من البيانات المدخلة.",
  login_error_invalid: "فشل تسجيل الدخول. تحقق من البيانات.",
  login_success: "تم تسجيل الدخول بنجاح.",
  submitting: "جارٍ الإرسال...",
  last30_vs_prev30: "آخر 30 / الـ 30 السابقة",
  fp_title: "استعادة كلمة المرور",
  fp_subtitle: "أدخل بريدك الإلكتروني لنرسل لك رمز تحقق لإعادة تعيين كلمة المرور.",

  fp_email_label: "البريد الإلكتروني",
  fp_email_placeholder: "name@example.com",

  fp_send_code: "إرسال الرمز",
  fp_sending: "جاري الإرسال…",
  fp_continue: "متابعة",
  fp_verifying: "جاري التحقق…",
  fp_set_password: "تعيين كلمة مرور جديدة",
  fp_saving: "جاري الحفظ…",

  fp_resend: "إعادة إرسال",
  fp_back_to_code: "رجوع لرمز التحقق",

  fp_remembered_password: "تذكّرت كلمة المرور؟",
  fp_back_to_login: "العودة لتسجيل الدخول",

  fp_otp_label: "أدخل رمز التحقق (6 خانات)",
  fp_new_password: "كلمة مرور جديدة",
  fp_confirm_password: "تأكيد كلمة المرور",
  fp_password_placeholder: "••••••••",

  fp_err_email_required: "الرجاء إدخال البريد الإلكتروني.",
  fp_err_email_invalid: "صيغة البريد الإلكتروني غير صحيحة.",
  fp_err_otp_invalid: "أدخل رمزًا صحيحًا مكوّنًا من 6 خانات.",
  fp_err_password_required: "الرجاء إدخال كلمة مرور جديدة.",
  fp_err_password_min: "كلمة المرور يجب أن تكون 8 أحرف فأكثر.",
  fp_err_confirm_required: "الرجاء تأكيد كلمة المرور.",
  fp_err_password_mismatch: "كلمتا المرور غير متطابقتين.",

  fp_toast_code_sent: "تم إرسال الرمز بنجاح.",
  fp_toast_code_verified: "تم التحقق من الرمز بنجاح.",
  fp_toast_password_set: "تم تعيين كلمة المرور بنجاح.",
  fp_toast_code_resent: "تم إعادة إرسال الرمز.",

  // 🔐 إعادة الإرسال / المؤقت
  fp_resend: "إعادة إرسال الرمز",
  fp_resend_in: "إعادة الإرسال بعد",
  fp_seconds: "ث",
  fp_toast_code_resent: "تم إعادة إرسال رمز التحقق بنجاح.",
  fp_toast_code_sent: "تم إرسال رمز التحقق بنجاح.",
  fp_toast_code_verified: "تم التحقق من الرمز بنجاح.",
  fp_toast_password_set: "تم تحديث كلمة المرور بنجاح.",
  fp_cooldown_message: "يرجى الانتظار قبل إعادة الإرسال.",
  fp_err_otp_expired: "انتهت صلاحية رمز التحقق. يرجى طلب رمز جديد.",

  // Index page
  about_title: "الاستشارات الذكية",
  slogan: "شريكك الرقمي.. لنمو مستدام لمشروعك في ظل",
  vision_2030: "رؤية ٢٠٣٠",
  about_paragraph: `نؤمن بأن كل مشروع يستحق أن ينمو بثقة واستدامة.
منصتك الذكية التي تجمعك بخبراء معتمدين يقدمون حلولًا مبتكرة وسريعة التنفيذ، لتقود نجاحك بخطى ثابتة نحو مستقبلٍ يواكب رؤية 2030.`,

  consulting: "الاستشارات",
  start_now: "ابدأ الآن",
  contact_us: "تواصل معنا",
  stats_consulting: "الاستشارات",
  stats_active_consultants: "نسبة المستشارين الفعّالين",
  stats_clients: "نسبة العملاء ",
  progress: "التقدم",
  growth: "نمو",
  percent_sign: "%",
  stats_updating: "جاري تحديث الإحصائيات...",
  retry: "إعادة المحاولة",
  svcs_empty: "لا توجد خدمات متاحة حالياً.",
  sidebar_item_home: "الرئيسية",

  svcs_tag: "الخدمات الاستشارية",
  svcs_h: "مجالات الاستشارة",
  svcs_p:
    "تقدّم منصة الاستشارات الذكية أكثر من مجرد خدمات متخصصة تغطي معظم احتياجات المنشآت الصغيرة والمتوسطة، وذلك عبر فريق من الخبراء المعتمدين في هذه المجالات الرئيسية:",

  svcs_read_more: "اقرأ المزيد",

  // About section headings
  about_tag: "لماذا نحن؟",
  about_subtitle: "لأننا نضع احتياجات منشأتك في قلب كل استشارة نقدمها",

  vision_title: "رؤيتنا",
  vision_text:
    "أن نكون البوصلةَ الرقميةَ لتمكين رواد الأعمال والمنشآت الصغيرة والمتوسطة، عبر حلولنا الاستشارية المتكاملة لقيادة المستقبل وتحقيق رؤية المملكة 2030.",

  mission_title: "رسالتنا",
  mission_text:
    "نحن منصةٌ رقميةٌ شاملةٌ لتمكين رواد الأعمال والمنشآت الصغيرة والمتوسطة. نقدّم حلولاً استشارية متكاملة تجمع بين الخبرة المعتمدة والأدوات التقنية المبتكرة، ونحلّل التحديات في الإدارة والمالية والقانون والتسويق لتصميم حلول مخصصة تدفع النمو المستدام، ونبني شراكات استراتيجية طويلة الأمد ملتزمين بأعلى معايير الجودة والمسؤولية المجتمعية، مساهمين في تحقيق رؤية 2030.",

  // Services
  svc_hr_h: "الاستشارات في إدارة الموارد البشرية",
  svc_hr_p:
    "بناء أنظمة موارد بشرية احترافية تشمل الهياكل التنظيمية والسياسات وإدارة الأداء والالتزام بنظام العمل السعودي.",

  svc_marketing_h: "الاستشارات في التسويق الرقمي",
  svc_marketing_p:
    "تطوير الهوية التسويقية، خطط التسويق الرقمي، إدارة الحملات الإعلانية، وتحليل السوق والمنافسين.",

  svc_legal_h: "الاستشارات القانونية التجارية",
  svc_legal_p:
    "صياغة ومراجعة العقود، حماية الملكية الفكرية، الامتثال القانوني، وإدارة المنازعات التجارية.",

  svc_gov_h: "الاستشارات في التعامل مع المنصات الحكومية",
  svc_gov_p:
    "تيسير التعامل مع وزارة التجارة، قوى، مدد، التأمينات الاجتماعية، أبشر، مقيم، بلدي، وكافة المنصات الحكومية.",

  svc_design_h: "الاستشارات في التصميم والهوية البصرية",
  svc_design_p:
    "تصميم الشعار والهوية البصرية الكاملة وواجهات المستخدم UI/UX والمطبوعات الرسمية.",

  svc_finance_h: "الاستشارات المالية",
  svc_finance_p:
    "التخطيط المالي، إعداد الميزانيات، تحليل التكاليف، والتقارير المالية وفق المعايير المحاسبية.",

  svc_training_h: "الاستشارات في التدريب والتطوير",
  svc_training_p:
    "تصميم البرامج التدريبية، تقييم فجوات المهارات، وبناء أنظمة إدارة التدريب.",

  svc_future_h: "الاستشارات المستقبلية",
  svc_future_p:
    "تقديم رؤى واستراتيجيات مبتكرة لاستباق التغيرات السوقية وضمان نمو مستدام للمنشآت.",

  about_tag: "لماذا نحن؟",
  about_subtitle: "الرسالة و الرؤية",

  vision_title: "رؤيتنا",
  vision_text:
    "أن نكون البوصلة الرقمية لتمكين رواد الأعمال والمنشآت الصغيرة والمتوسطة من خلال حلولنا الاستشارية المتكاملة لقيادة المستقبل وتحقيق رؤية المملكة 2030.",

  mission_title: "رسالتنا",
  mission_text:
    "نحن منصة رقمية شاملة لتمكين رواد الأعمال والمنشآت الصغيرة والمتوسطة. نقدم حلولاً استشارية متكاملة تجمع بين الخبرة المعتمدة والأدوات التقنية المبتكرة. نحلل التحديات في مجالات الإدارة والمالية والقانونية والتسويقية لتصميم حلول مخصصة تدفع عجلة النمو المستدام. نؤمن بأن نجاح عملائنا هو محور نجاحنا، ونسخر إمكاناتنا لبناء شراكات استراتيجية طويلة الأمد، مع الالتزام بأعلى معايير الجودة والمسؤولية المجتمعية، مساهمين بذلك في تحقيق رؤية المملكة 2030.",

  values_title: "الأهداف الاستراتيجية",
  values_list: [
    "تمكين المنشآت السعودية لتحقيق النمو المستدام والتميز في أدائها",
    "الريادة في النمو والاستدامة المالية ضمن قطاع الاستشارات الرقمية",
    "التميز في تقديم حلول رقمية متكاملة ومبتكرة",
    "الريادة في ابتكار حلول استشارية ذكية تلبي مستقبل الأعمال",
  ],

  // قيمنا (بطاقات: عنوان + وصف) — تُستخدم في قسم القيم
  values_cards_title: "قيمنا",
  values_cards: [
    {
      title: "الريادة الرقمية",
      desc: "نقود الابتكار الرقمي ونوجّه التحول برؤية وخبرة.",
    },
    {
      title: "التمكين المستدام",
      desc: "نُمكّن المنشآت لتحقيق نمو مستدام وتأثير طويل الأمد.",
    },
    {
      title: "الشراكة الاستراتيجية",
      desc: "نبني شراكات دائمة تعزز النجاح المشترك والقيمة المتبادلة.",
    },
    {
      title: "الأصالة والجودة",
      desc: "نلتزم بالتميز الحقيقي ونحافظ على أعلى معايير الجودة.",
    },
  ],

  // نصوص عامة (إن لزم)
  values_tag: "هويتنا",
  values_h: "قيمنا وأهدافنا",
  values_p:
    "نعكس قيمنا في عملنا اليومي، ونحدد أهدافًا واضحة تقود مسيرتنا نحو التميز.",

  contact_us: "تواصل معنا",
  // UNIQUE VALUE
  unique_h1: "مميزاتنا",
  unique_h2: "القيمة الفريدة",
  unique_p:
    "المنصة الأولى التي تدمج بين الخبرة الاستشارية المتخصصة والذكاء التقني في حل موحّد، لتقديم استشارات شاملة وسريعة للمنشآت الصغيرة والمتوسطة، بأسعار ليست فقط مناسبة، بل مرنة تمامًا مع إمكانياتها.",

  uv_tech: "الذكاء التقني في حل موحّد",
  uv_inclusive: "الشمولية",
  uv_price: "المرونة في الأسعار",
  uv_speed: "السرعة",
  uv_expertise: "الخبرة المتخصصة",

  values_tag: "هويتنا",
  values_h: "قيمنا وأهدافنا",
  values_p:
    "نعكس قيمنا في كل ما نقوم به ونحدد أهدافًا واضحة تقودنا نحو التميز.",
  values_tag: "هويتنا",
  values_h: "قيمنا وأهدافنا",
  values_p:
    "نعكس قيمنا في كل ما نقوم به ونحدد أهدافًا واضحة تقودنا نحو التميز.",
  values_tag: "هويتنا",
  values_h: "قيمنا وأهدافنا",
  values_p:
    "نعكس قيمنا في عملنا اليومي، ونحدد أهدافًا واضحة تقود مسيرتنا نحو التميز.",

  // 1) Digital Leadership
  val_digital_lead_title: "الريادة الرقمية",
  val_digital_lead_desc:
    "قيادة التحول الرقمي بمنهجية حديثة تدعم التنافسية والابتكار.",

  // 2) Sustainable Empowerment
  val_sustain_emp_title: "التمكين المستدام",
  val_sustain_emp_desc:
    "تمكين العملاء بحلول طويلة الأمد تعزز الاستدامة والنمو.",

  // 3) Strategic Partnership
  val_strat_part_title: "الشراكة الاستراتيجية",
  val_strat_part_desc: "نبني شراكات فعّالة تحقق مصالح مشتركة وقيمة مستمرة.",

  // 4) Authenticity and Quality
  val_auth_quality_title: "الأصالة والجودة",
  val_auth_quality_desc: "ممارسات أصيلة ومعايير جودة عالية في كل ما نقدمه.",
  values_list: [
    {
      title: "الريادة الرقمية",
      desc: "نقود الابتكار الرقمي ونوجّه التحول برؤية وخبرة.",
    },
    {
      title: "التمكين المستدام",
      desc: "نُمكّن المنشآت لتحقيق نمو مستدام وتأثير طويل الأمد.",
    },
    {
      title: "الشراكة الاستراتيجية",
      desc: "نبني شراكات دائمة تعزز النجاح المشترك والقيمة المتبادلة.",
    },
    {
      title: "الأصالة والجودة",
      desc: "نلتزم بالتميز الحقيقي ونحافظ على أعلى معايير الجودة.",
    },
  ],
  // Service
  svc_hr_h: "الاستشارات في مجال إدارة الموارد البشرية",
  svc_hr_h_full: "الاستشارات في مجال إدارة الموارد البشرية",

  svc_hr_desc:
    "نقدّم استشارات متخصصة لمساعدة المنشآت الصغيرة والمتوسطة في بناء أنظمة موارد بشرية احترافية تتماشى مع أفضل الممارسات، وتدعم تحقيق التوطين، وتحسّن تجربة الموظف داخل بيئة العمل.",
  svc_hr_pillars_title: "أبرز المجالات",
  svc_hr_pillars: [
    "svc_hr_pt_1",
    "svc_hr_pt_2",
    "svc_hr_pt_3",
    "svc_hr_pt_4",
    "svc_hr_pt_5",
    "svc_hr_pt_6",
    "svc_hr_pt_7",
  ],
  svc_hr_pt_1: "إعداد الهياكل التنظيمية حسب حجم ونشاط المنشأة",
  svc_hr_pt_2:
    "تصميم سياسات الموارد البشرية (الإجازات، الترقيات، الحضور، العمل عن بُعد)",
  svc_hr_pt_3: "تنظيم ملفات الموظفين ونماذج التوظيف",
  svc_hr_pt_4: "دعم نظام إدارة الأداء والمكافآت",
  svc_hr_pt_5: "بناء المسارات الوظيفية وخطط التطوير الداخلي",
  svc_hr_pt_6: "المساعدة في تطبيق أنظمة العمل السعودية وتحديثاتها",
  svc_hr_pt_7: "تقديم المشورة في إجراءات التوظيف والفصل وفق النظام",
  svc_hr_highlight_1: "امتثال لأنظمة العمل وتحديثاتها مع سياسات داخلية واضحة",
  svc_hr_highlight_2: "رفع كفاءة الأداء والاحتفاظ بالموهوبين",
  svc_hr_highlight_3: "تحسين تجربة الموظف وثقافة المنظمة",
  svc_hr_cta_h: "ابدأ ببناء بنية موارد بشرية قوية",
  svc_hr_cta_p: "تواصل معنا لنقترح عليك حزمة ملائمة لحجم منشأتك واحتياجها.",

  // ====== العلامة التجارية / العام ======
  admin_brand_title: "مرحبا إحساس ",
  admin_brand_sub: "إحساس للاستشارات",

  admin_search_placeholder: "ابحث في القائمة...",

  admin_logged_in_as: "مسجل الدخول كـ",
  admin_consulting_manager: "مدير الاستشارات",

  // ====== مجموعات وعناصر الشريط الجانبي ======
  sidebar_brand: "منصة الاستشارات الذكية",
  sidebar_group_account: "الحساب",
  sidebar_group_consultations: "الاستشارات",

  sidebar_item_account_settings: "إعدادات الحساب",
  sidebar_item_office_management: "إدارة المنشأة",

  sidebar_item_create: "إنشاء استشارة",
  sidebar_item_my_consultations: "استشاراتي",
  sidebar_item_coming_session_consultations: "استشارات مرئية (القادمة)",
  sidebar_item_coming_chat_consultations: "استشارات فورية (القادمة)",
  sidebar_item_profile: "الملف الشخصي",
  sidebar_item_account_settings: "إعدادات الحساب",
  sidebar_item_all_consultations: "جميع الاستشارات",

  menu_profile: "الملف الشخصي",
  menu_account_settings: "إعدادات الحساب",
  menu_logout: "تسجيل الخروج",

  // ====== صفحة الحساب – العنوان والتبويبات ======
  account_settings_title: "إعدادات الحساب",
  account_settings_subtitle: "قم بتحديث بيانات العميل والعنوان ومعلومات البنك.",
  office_settings_title: "إعدادات الحساب",
  office_settings_subtitle: "قم بتحديث بيانات مكتب الاستشاري والعنوان ومعلومات البنك.",
  account_tab_account: "الحساب",
  account_tab_security: "الأمان",
  account_last_updated_hint: "تم التحديث منذ لحظات",

  // ====== الحساب – بيانات العميل ======
  account_section_client: "بيانات العميل",

  account_field_client_name: "اسم العميل",
  account_field_client_name_placeholder: "أدخل الاسم الكامل للعميل",

  account_field_activity: "نشاط العميل",
  account_field_activity_placeholder: "أدخل النشاط الرئيسي للعميل",

  account_field_manager_name: "اسم المسؤول",
  account_field_manager_name_placeholder: "أدخل اسم مدير الحساب / المسؤول",

  // ====== الحساب – العنوان ======
  account_section_address: "العنوان",

  account_field_city: "المدينة",
  account_field_city_placeholder: "أدخل اسم المدينة",

  account_field_district: "الحي",
  account_field_district_placeholder: "أدخل اسم الحي / المنطقة",

  account_field_street: "الشارع",
  account_field_street_placeholder: "أدخل اسم الشارع",

  account_field_building_number: "رقم المبنى",
  account_field_building_number_placeholder: "أدخل رقم المبنى",

  account_field_additional_number: "الرقم الإضافي",
  account_field_additional_number_placeholder: "أدخل الرقم الإضافي (إن وجد)",

  account_field_postal_code: "الرمز البريدي",
  account_field_postal_code_placeholder: "أدخل الرمز البريدي",

  account_field_short_address: "وصف مختصر للعنوان",
  account_field_short_address_placeholder: "أدخل وصفاً مختصراً للعقار / المقر",

  // ====== الحساب – معلومات البنك ======
  account_section_bank: "معلومات البنك",

  account_field_holder_name: "اسم صاحب الحساب",
  account_field_holder_name_placeholder: "أدخل اسم صاحب الحساب البنكي",

  account_field_iban: "رقم الآيبان / الحساب",
  account_field_iban_placeholder: "أدخل رقم الآيبان أو رقم الحساب",

  account_field_bank_name: "اسم البنك",
  account_field_bank_name_placeholder: "أدخل اسم البنك",

  // ====== الحساب – الأزرار ======
  account_btn_save: "حفظ التغييرات",
  account_btn_cancel: "إلغاء",

  account_required_fields_note: "الحقول المشار إليها بـ * حقول إلزامية.",
  // create consulting
  consult_create_title: "إنشاء استشارة",
  consult_create_subtitle: "املأ التفاصيل التالية لطلب استشارة جديدة",

  consult_field_subject: "موضوع الاستشارة",
  consult_field_subject_placeholder:
    "مثال: إدارة علاقات العملاء في الخدمات المصرفية للشركات",
  consult_field_description: "الوصف",
  consult_field_description_placeholder:
    "اشرح تفاصيل الاستشارة التي تحتاجها...",
  consult_field_activity: "النشاط",
  consult_field_activity_placeholder: "اختر النشاط",
  consult_activity_corporate_banking: "الخدمات المصرفية للشركات",
  consult_activity_sme: "منشآت صغيرة ومتوسطة",
  consult_activity_retail: "الأفراد",

  consult_field_type: "النوع",
  consult_field_type_placeholder: "اختر نوع الاستشارة",
  consult_type_general: "استشارة عامة",
  consult_type_followup: "متابعة",
  consult_type_urgent: "عاجلة",

  consult_section_attachments: "المرفقات",
  consult_section_attachments_optional: "(اختياري)",
  consult_attachments_label: "ارفع الملفات الخاصة بهذه الاستشارة",
  consult_office_label: "ارفع الملفات الخاصة بهذه المكتب",
  consult_validation_subject_required: "عنوان الاستشارة مطلوب.",
  consult_validation_type_required: "نوع الاستشارة مطلوب.",
  consult_validation_date_required: "تاريخ الموعد مطلوب.",
  consult_validation_time_required: "وقت الموعد مطلوب.",
  consult_validation_url_required: "رابط الجلسة مطلوب.",
  consult_attachments_hint:
    "يمكنك رفع ملفات PDF أو صور  (حتى 2 ميجابايت لكل ملف)",

  consult_section_contact_methods: "طرق التواصل مع المستشار",
  consult_method_chat_title: "المحادثة الفورية",
  consult_method_chat_desc: "محادثة نصية مباشرة مع المستشار داخل المنصة",
  consult_method_video_title: "مكالمة فيديو",
  consult_method_video_desc:
    "جلسة مرئية مباشرة عبر الإنترنت مع إمكانية مشاركة الشاشة",
  consult_method_select: "اختر هذه الطريقة",
  consult_method_none_title: "بدون طريقة تواصل",

  consult_btn_save_draft: "حفظ كمسودة",
  consult_btn_create: "إنشاء",
  consult_btn_clear: "مسح الحقول",
  consult_required_note: "الحقول المشار إليها بعلامة * مطلوبة",
  consult_create_success: "تم إنشاء الاستشارة بنجاح.",
  consult_update_success: "تم تحديث الاستشارة بنجاح.",
  consult_saved_success: "تم حفظ الاستشارة بنجاح.",

  // Footer
  footer_brand: "منصة الاستشارات الذكية",
  footer_brand_alt: "منصة الاستشارات الذكية",
  footer_phone_label: "خدمة العملاء",
  footer_whatsapp: "واتساب",
  footer_rights: "جميع الحقوق محفوظة",
  footer_vision2030: "رؤية 2030",

  // Page titles
  consult_my_title: "استشاراتي",
  consult_my_subtitle: "استعرض جميع الاستشارات التي قمت بتقديمها وحالتها.",

  consult_coming_session_title: "الاستشارات القادمة (جلسة)",
  consult_coming_session_subtitle:
    "استشارات الجلسات المجدولة — صفِّها وانضم عند الموعد.",
  consult_coming_chat_title: "الاستشارات القادمة (محادثة)",
  consult_coming_chat_subtitle:
    "استشارات المحادثة المجدولة — افتح المحادثة عند الموعد.",
  consult_coming_back_my: "كل استشاراتي",
  consult_coming_search_placeholder: "موضوع أو رقم…",
  consult_coming_search_hint: "ابحث بالموضوع أو رقم الاستشارة أو جهة الاتصال.",
  consult_coming_filter_label: "تصفية الاستشارات",
  consult_coming_filter_all: "الكل",
  consult_coming_filter_today: "اليوم",
  consult_coming_filter_this_week: "هذا الأسبوع",
  consult_coming_filter_under_study: "تحت الدراسة",
  consult_coming_filter_active_hint: "الفلاتر النشطة",
  consult_coming_filter_clear_all: "مسح الكل",
  consult_coming_filter_status: "فلتر سريع",
  consult_coming_filter_search: "بحث",
  consult_coming_filter_type: "النوع",
  consult_coming_filter_payment: "الدفع",
  consult_coming_filter_sort: "الترتيب",
  consult_coming_filter_more: "فلاتر إضافية",
  consult_coming_filter_appointment_from: "موعد من",
  consult_coming_filter_appointment_to: "موعد إلى",
  consult_coming_filter_appointment_range: "نطاق الموعد",
  consult_coming_date_range_placeholder: "اختر نطاق التاريخ",
  consult_coming_date_range_apply: "تطبيق",
  consult_coming_date_range_clear: "مسح",
  consult_coming_filter_created_from: "تاريخ الإنشاء من",
  consult_coming_filter_created_to: "تاريخ الإنشاء إلى",
  consult_coming_table_appointment: "الموعد",
  consult_coming_empty: "لا توجد استشارات قادمة حالياً.",
  consult_coming_empty_filtered: "لا توجد استشارات تطابق الفلاتر المحددة.",
  consult_coming_empty_hint: "عندما تكون لديك استشارات مجدولة، ستظهر هنا.",
  consult_coming_load_failed: "تعذّر تحميل الاستشارات القادمة.",
  consult_coming_sort_appointment_date: "تاريخ الموعد",
  consult_coming_sort_appointment_time: "وقت الموعد",
  consult_coming_sort_created_at: "تاريخ الإنشاء",
  consult_coming_sort_price: "السعر",
  consult_coming_sort_number: "رقم الاستشارة",
  consult_coming_sort_status: "الحالة",
  consult_coming_order_asc: "تصاعدي",
  consult_coming_order_desc: "تنازلي",
  consult_filter_payment_all: "كل حالات الدفع",
  payment_status_cancelled: "ملغاة",
  payment_status_failed: "فشل",

  // Search & filters
  consult_my_search_placeholder: "موضوع أو وصف…",
  consult_my_search_hint: "ابحث بموضوع الاستشارة أو الوصف.",
  consult_filter_status_all: "كل الحالات",
  consult_filter_activity_all: "كل الأنشطة",

  // Status labels
  // Status labels
  consult_filter_type_all: "كل الأنواع",
  consult_status_open: "تحت الدراسة",
  consult_status_draft: "مسودة",
  consult_status_in_progress: "جاري التنفيذ",
  consult_status_answered: "منتهية",
  consult_status_closed: "مغلقة",
  consult_status_under_review: "تحت المراجعة",
  consult_status_new: "جديد",
  consult_status_finished: "منتهية",
  consult_filter_type_all: "كل الأنواع",
  consult_open: "تحت الدراسة",
  consult_draft: "مسودة",
  consult_in_progress: "جاري التنفيذ",
  consult_answered: "منتهية",
  consult_closed: "مغلقة",
  consult_under_review: "تحت المراجعة",
  consult_new: "جديد",
  consult_finished: "منتهية",

  // Activities
  consult_activity_unknown: "نشاط آخر",
  consult_activity_corporate_banking: "الخدمات المصرفية للشركات",
  consult_activity_sme: "قطاع المنشآت الصغيرة والمتوسطة",
  consult_activity_retail: "الخدمات المصرفية للأفراد",

  // Types
  consult_type_general: "استشارة عامة",
  consult_type_followup: "استشارة متابعة",
  consult_type_urgent: "استشارة عاجلة",

  // Empty state
  consult_my_empty_title: "لا توجد استشارات حتى الآن",
  consult_my_empty_subtitle: "لم تقم بتقديم أي استشارات حتى الآن.",
  consult_my_empty_cta: "إنشاء استشارة جديدة",
  consult_my_empty_filtered: "لا توجد استشارات تطابق الفلاتر.",
  consult_filter_label: "تصفية حسب الحالة",
  consult_filter_all: "الكل",
  consult_filter_clear: "إزالة الفلتر",
  consult_filter_clear_all: "مسح الكل",
  consult_filter_status: "الحالة",
  consult_filter_search: "بحث",
  consult_filter_type: "النوع",
  consult_filter_type_search: "ابحث في التصنيفات...",
  consult_filter_type_empty: "لا توجد تصنيفات",
  consult_filter_active_hint: "نتائج مفلترة",

  // Table headers
  consult_table_number: "رقم الاستشارة",
  consult_table_subject: "الموضوع",
  consult_table_date: "التاريخ",
  consult_table_activity: "النشاط",
  consult_table_type: "النوع",
  consult_table_created_at: "تاريخ الانشاء",

  consult_table_method: "طريقة التنفيذ",
  consult_table_status: "الحالة",
  consult_table_actions: "الإجراءات",

  // Table helpers
  consult_table_no_desc: "لا يوجد وصف مضاف",
  consult_table_showing: "يعرض",
  consult_table_of: "من",
  consult_table_entries: "سجل",
  consult_table_prev: "السابق",
  consult_table_next: "التالي",
  consult_table_page: "الصفحة",

  // Methods
  consult_method_session_title: "جلسة",
  consult_method_chat_title: "محادثة",
  consult_method_video_title: "مكالمة مرئية",
  consult_method_link: "رابط",

  // Actions (dropdown)
  consult_action_view: "عرض التفاصيل",
  consult_copy_number: "نسخ رقم الاستشارة",
  consult_action_edit: "تعديل الاستشارة",
  consult_action_cancel: "إلغاء الاستشارة",

  // صفحة بيانات المكتب
  office_title: "بيانات المكتب",
  office_subtitle:
    "إدارة بيانات السجل التجاري وبيانات المكتب والمستندات الرسمية.",

  office_section_info: "معلومات المكتب",
  office_section_upload: "رفع الملفات",

  office_optional: "(اختياري)",

  office_field_crn: "رقم السجل التجاري",
  office_field_crn_placeholder: "أدخل رقم السجل التجاري",

  office_field_establishment: "رقم المنشأة",
  office_field_establishment_placeholder: "أدخل رقم المنشأة",

  office_field_unified_no: "الرقم الموحّد",
  office_field_unified_no_placeholder: "أدخل الرقم الموحّد",

  office_field_tax_no: "الرقم الضريبي",
  office_field_tax_no_placeholder: "أدخل الرقم الضريبي",

  office_field_insurance_no: "رقم التأمين",
  office_field_insurance_no_placeholder: "أدخل رقم التأمين",

  office_existing_files_title: "الملفات الحالية",
  office_existing_logo: "الشعار الحالي",
  office_existing_letterhead: "الترويسة الحالية",
  office_existing_unified: "ملف الرقم الموحّد الحالي",
  office_existing_establishment: "ملف المنشأة الحالي",
  office_existing_registration: "ملف السجل التجاري الحالي",

  office_upload_logo: "الشعار (اختياري)",
  office_upload_logo_placeholder: "اختر ملف الشعار",

  office_upload_letterhead: "الترويسة (اختياري)",
  office_upload_letterhead_placeholder: "اختر ملف الترويسة",

  office_upload_unified: "ملف الرقم الموحّد (اختياري)",
  office_upload_unified_placeholder: "اختر مستند الرقم الموحّد",

  office_upload_establishment: "مستند المنشأة (اختياري)",
  office_upload_establishment_placeholder: "اختر مستند المنشأة",

  office_upload_registration: "مستند السجل التجاري (اختياري)",
  office_upload_registration_placeholder: "اختر مستند السجل التجاري",

  office_btn_save: "حفظ بيانات المكتب",
  office_btn_reload: "إعادة التحميل",
  office_note_optional: "كل الحقول اختيارية، قم بتعبئة المتوفر لديك فقط.",

  office_choose_doc_type: "اختر نوع المستند",
  office_upload_hint:
    "اختر ملفًا لنوع المستند المحدد. يمكنك رفع صورة أو pdf لا يزيد حجمه عن 2M  لكل نوع.",
  office_saved_success: "تم حفظ بيانات المكتب بنجاح ",

  consult_chat_date: "تاريخ الموعد",
  consult_chat_time: "الوقت",

  consult_video_date: "تاريخ الموعد",
  consult_video_time: "الوقت",
  consult_video_url: "رابط الجلسة",
  consult_video_url_placeholder: "رابط زوم / تيمز / ميت",

  // UserProfile
  status_inactive: "غير نشط",
  status_active: "نشط",
  profile_title: "الملف الشخصي",
  profile_subtitle: "قم بتحديث معلوماتك الشخصية وإعدادات الحساب.",

  section_about_client: "عن العميل",
  section_user: "المستخدم",
  section_address: "العنوان",
  section_bank: "بيانات البنك",
  section_office: "اسم المكتب",
  section_documents: "المستندات",

  field_client: "العميل",
  field_manager: "المدير",
  field_client_type: "نوع العميل",
  field_activity: "النشاط",

  field_user_name: "اسم المستخدم",
  field_email: "البريد الإلكتروني",
  field_phone: "رقم الجوال",
  field_status: "الحالة",
  field_role: "الدور",

  field_city: "المدينة",
  field_district: "الحي",
  field_street: "الشارع",
  field_building_no: "رقم المبنى",
  field_additional_no: "الرقم الإضافي",
  field_postal_code: "الرمز البريدي",
  field_short_address: "العنوان المختصر",

  field_account_holder: "اسم صاحب الحساب",
  field_account_no: "رقم الحساب",
  field_bank_name: "البنك",

  field_commercial_reg: "رقم السجل التجاري",
  field_establishment_no: "رقم المنشأة",
  field_unified_no: "الرقم الموحد",
  field_tax_no: "الرقم الضريبي",
  field_insurance_no: "رقم التأمين",

  // Security tab
  security_section_title: "الأمان وتغيير كلمة المرور",

  security_current_password: "كلمة المرور الحالية",
  security_current_password_placeholder: "أدخل كلمة المرور الحالية",

  security_new_password: "كلمة المرور الجديدة",
  security_new_password_placeholder: "أدخل كلمة مرور جديدة",

  security_confirm_password: "تأكيد كلمة المرور الجديدة",
  security_confirm_password_placeholder: "أعد إدخال كلمة المرور الجديدة",

  security_password_requirements_title: "متطلبات كلمة المرور",
  security_password_req_len: "الحد الأدنى 8 أحرف (كلما زادت كان أفضل)",
  security_password_req_lower: "تحتوي على حرف صغير واحد على الأقل (a-z)",
  security_password_req_number_symbol:
    "تحتوي على رقم أو رمز أو مسافة واحدة على الأقل",

  security_btn_save: "حفظ كلمة المرور",
  security_btn_saving: "جاري الحفظ...",
  security_btn_rest: "إعادة تعيين",

  security_password_hint: "استخدم كلمة مرور قوية وغير مستخدمة سابقًا.",
  security_password_success: "تم تحديث كلمة المرور بنجاح.",
  security_password_failed: "فشل تحديث كلمة المرور، تحقق من البيانات.",

  // toast
  account_btn_saving: "جاري الحفظ...",
  account_saved_success: "تم حفظ البيانات بنجاح",
  account_saved_failed: "فشل حفظ البيانات، حاول مرة أخرى",
  consult_method_session: "تم اختيار طريقة الجلسة",
  consult_method_chat: "تم اختيار طريقة المحادثة",
  consult_type_hr: "الموارد البشرية",
  consult_type_marketing: "التسويق",
  consult_type_government: "المنصات الحكومية",

  cookie_err_auth_user_missing:
    "بيانات الجلسة غير موجودة. يرجى تسجيل الدخول مرة أخرى.",
  cookie_err_auth_user_parse_failed:
    "تعذر قراءة بيانات الجلسة. يرجى تسجيل الدخول مرة أخرى.",
  cookie_err_auth_token_missing:
    "انتهت صلاحية الجلسة. يرجى تسجيل الدخول مرة أخرى.",
  cookie_err_client_id_not_found:
    "لم يتم العثور على معرف العميل في بيانات الجلسة. يرجى تسجيل الدخول مرة أخرى.",
  cookie_err_consultant_id_not_found:
    "لم يتم العثور على معرف المستشار في بيانات الجلسة. يرجى تسجيل الدخول مرة أخرى.",
  cookie_err_office_id_not_found:
    "لم يتم العثور على معرف المكتب في بيانات الجلسة. يرجى تسجيل الدخول مرة أخرى.",
  cookie_err_user_data_not_found:
    "لم يتم العثور على بيانات المستخدم في الجلسة. يرجى تسجيل الدخول مرة أخرى.",

  // ===== Common =====
  back: "رجوع",
  edit: "تعديل",
  save: "حفظ",
  publish: "نشر",

  saving: "جاري الحفظ...",
  loading: "جاري التحميل...",

  // ===== Office Details =====
  office_details_title: "تفاصيل المكتب",
  office_details_subtitle: "عرض بيانات المكتب والمستندات",
  office_info: "معلومات المكتب",
  office_documents: "المستندات",
  office_no_docs: "لا توجد مستندات مرفوعة.",

  office_field_id: "المعرف",
  office_field_owner_id: "معرف المالك",
  office_field_crn: "رقم السجل التجاري",
  office_field_establishment: "رقم المنشأة",
  office_field_unified_no: "الرقم الموحد",
  office_field_tax_no: "الرقم الضريبي",
  office_field_insurance_no: "رقم التأمينات",

  office_existing_logo: "الشعار",
  office_existing_letterhead: "ورق المراسلات",
  office_existing_unified: "ملف الرقم الموحد",
  office_existing_establishment: "ملف المنشأة",
  office_existing_registration: "ملف السجل التجاري",

  // ===== Consultation Edit =====
  consult_edit_title: "تعديل الاستشارة",
  consult_edit_subtitle: "تحديث تفاصيل الاستشارة",

  consultation_status: "حالة الاستشارة",
  consultation_info: "معلومات الاستشارة",

  consult_table_number: "الرقم",
  consult_table_date: "التاريخ",
  consult_table_activity: "النشاط",
  consult_table_type: "النوع",
  consult_table_subject: "الموضوع",

  offer_price: "سعر العرض",
  offer_details: "تفاصيل العرض",
  offer_provider_info: "معلومات مقدم العرض",
  offer_before_tax: "قبل الضريبة",
  tax_percent: "نسبة الضريبة",
  total_amount: "الإجمالي",
  update_offer: "تحديث العرض",

  contact_method: "طريقة التواصل",
  method: "الطريقة",
  date: "التاريخ",
  time: "الوقت",
  session_link: "رابط الجلسة",
  chat_link: "رابط المحادثة",

  priority: "الأولوية",
  normal: "عادي",
  urgent: "عاجل",
  description: "الوصف",

  attachments: "المرفقات",
  add_attachment: "إضافة",
  no_attachments: "لا توجد مرفقات بعد.",
  view: "عرض",
  delete: "حذف",

  consultant_response: "رد المستشار",
  consultant_response_placeholder: "اكتب ردك هنا...",
  save_response: "حفظ الرد",

  // Status options
  consult_under_study: "تحت الدراسة",
  consult_open: "مفتوحة",
  consult_in_progress: "قيد التنفيذ",
  consult_answered: "مجاب عليها",
  consult_closed: "مغلقة",

  // Activity options
  consult_activity_corporate_banking: "خدمات مصرفية للشركات",
  consult_activity_sme: "منشآت صغيرة ومتوسطة",
  consult_activity_retail: "تجزئة",

  consult_method_chat: "محادثة",
  consult_method_session: "جلسة",

  consult_details_title: "تفاصيل الاستشارة",
  consult_details_subtitle: "عرض معلومات الاستشارة",

  back: "رجوع",
  accept: "قبول",
  reject: "رفض",

  consultation_status: "حالة الاستشارة",
  status: "الحالة",

  consult_status_under_study: "تحت الدراسة",
  consult_status_open: "مفتوحة",
  consult_status_in_progress: "قيد التنفيذ",
  consult_status_answered: "تم الرد",
  consult_status_closed: "مغلقة",
  consult_status_accepted: "مقبولة",
  consult_status_rejected: "مرفوضة",

  consultation_info: "معلومات الاستشارة",
  consult_table_number: "الرقم",
  consult_table_date: "التاريخ",
  consult_table_activity: "النشاط",
  consult_table_type: "النوع",

  offer_price: "سعر العرض",
  offer_before_tax: "قبل الضريبة",
  tax_percent: "نسبة الضريبة",
  total_amount: "الإجمالي",

  contact_method: "طريقة التواصل",
  method: "الطريقة",
  date: "التاريخ",
  time: "الوقت",
  session_link: "رابط الجلسة",
  consult_method_chat: "محادثة",
  consult_method_session: "جلسة",

  consult_table_subject: "الموضوع",
  priority: "الأولوية",
  normal: "عادي",
  urgent: "عاجل",
  description: "الوصف",

  attachments: "المرفقات",
  no_attachments: "لا توجد مرفقات.",
  view: "عرض",

  consultant_response: "رد المستشار",
  no_response: "لا يوجد رد حتى الآن.",

  processing: "جاري المعالجة...",
  loading: "جاري التحميل...",

  // contact us
  contact_company_name: "اسم الشركة",
  contact_company_name_ph: "اكتب اسم شركتك",
  contact_title: "تواصل معنا",
  contact_subtitle: "نحن هنا لمساعدتك. أرسل لنا رسالتك وسنعود إليك سريعًا.",
  contact_support_title: "الدعم والاستفسارات",
  contact_support_desc: "تواصل معنا عبر الهاتف أو البريد لأي سؤال.",
  contact_office_title: "مكتبنا",
  contact_office_desc: "يسعدنا استقبالكم أو التواصل معنا إلكترونيًا.",
  contact_office_address:
    "الرياض، المملكة العربية السعودية — (ضع العنوان الحقيقي هنا)",
  contact_map_placeholder: "خريطة الموقع",
  contact_social_title: "تابعنا",

  contact_form_title: "أرسل رسالة",
  contact_form_desc: "املأ النموذج وسنتواصل معك في أقرب وقت.",

  contact_name: "الاسم الكامل",
  contact_email: "البريد الإلكتروني",
  contact_phone: "رقم الجوال",
  contact_subject: "عنوان الرسالة",
  contact_service: "نوع الخدمة",
  contact_message: "الرسالة",

  contact_name_ph: "اكتب اسمك",
  contact_email_ph: "example@email.com",
  contact_phone_ph: "+966...",
  contact_subject_ph: "موضوع الرسالة",
  contact_service_all: "اختر الخدمة",
  contact_message_ph: "اكتب تفاصيل طلبك هنا...",
  contact_send: "إرسال",
  contact_sent: "تم إرسال رسالتك بنجاح ",

  // steps titles (missing keys)
  step_customer: "بيانات العميل",
  step_address: "العنوان الوطني",
  step_bank: "البيانات البنكية",
  step_org: "بيانات المنشأة",

  // sidebar types (if you want them as keys too)
  type_client: "عميل",
  type_consultant: "مستشار",
  type_office: "مكتب استشارات",

  // dropdown options
  opt_entrepreneur: "رواد أعمال",
  opt_nascent: "منشأة ناشئة",
  opt_small_business: "منشأة صغيرة",

  opt_individual: "فردي",
  opt_consulting_office: "مكتب استشارات",

  // otp misc
  otp_invalid: "الرمز غير صحيح، حاول مرة أخرى.",
  verified_alert: "تم التحقق بنجاح ",

  user_type: "نوع المستخدم",
  selected: "تم الاختيار",
  requirements_and_approval: "المتطلبات والموافقة",
  valid_data: "بيانات صحيحة",
  valid_data_hint: "تأكد من مطابقة السجل التجاري.",
  active_mobile: "رقم جوال مفعّل",
  active_mobile_hint: "سيصلك رمز تحقق عبر الرسائل.",
  official_email: "بريد رسمي",
  official_email_hint: "لإشعارات العقود والفواتير.",
  progress: "التقدّم",

  // stepper
  step: "الخطوة",
  of: "من",

  // select hints
  choose_client_type_hint: "اختر نوع العميل المناسب",
  choose_consultant_type_hint: "اختر نوع المستشار",

  // labels step 1
  client_type: "نوع العميل",
  consultant_type: "نوع المستشار",
  org_name: "اسم المنشأة",
  org_name_ph: "مثال: منصة الاستشارات الذكية",
  activity: "النشاط",
  activity_ph: "مثال: استشارات أعمال",
  simple_description: "وصف مبسط",
  simple_description_hint: "اكتب وصفًا مختصرًا عن المنشأة أو الخدمة",
  simple_description_ph: "اكتب وصفًا مختصرًا...",
  manager_name: "اسم المدير",
  manager_name_ph: "مثال: أحمد العتيبي",
  mobile: "رقم الجوال",
  mobile_ph: "05XXXXXXXX",
  official_email_label: "الإيميل الرسمي",
  official_email_ph: "name@company.sa",

  // step 2
  region: "المنطقة",
  city: "المدينة",
  district: "الحي",
  street: "الشارع",
  building_no: "رقم المبنى",
  zip: "الرمز البريدي",
  extra_no: "الرقم الإضافي",
  short_address: "العنوان المختصر",
  address_region_ph: "مثال: منطقة الرياض",
  address_city_ph: "مثال: الرياض",
  address_district_ph: "مثال: العليا",
  address_street_ph: "مثال: طريق الملك فهد",
  address_building_number_ph: "مثال: 1234",
  address_additional_number_ph: "مثال: 5678",
  address_postal_code_ph: "مثال: 12345",
  address_short_address_ph: "مثال: 1234 طريق الملك فهد، الرياض",
  office_address_city_ph: "مثال: الرياض",
  office_address_district_ph: "مثال: العليا",
  office_address_street_ph: "مثال: طريق الملك فهد",
  office_address_building_number_ph: "مثال: 1234",
  office_address_additional_number_ph: "مثال: 5678",
  office_address_postal_code_ph: "مثال: 12345",
  office_address_short_address_ph: "مثال: 1234 طريق الملك فهد، الرياض",

  // step 3
  bank_owner: "اسم صاحب الحساب",
  bank_name: "اسم البنك",
  bank_account: "رقم الحساب البنكي",
  iban: "IBAN",
  iban_ph: "SAxx xxxx xxxx xxxx xxxx xxxx",
  tax_no: "الرقم الضريبي",

  // step 4
  cr_no: "رقم السجل",
  org_no: "رقم المنشأة",
  unified_no: "الرقم الموحد",
  logo_attach: "مرفق الشعار",
  letterhead_attach: "الورق الرسمي",

  declarations: "الإقرارات",
  accept_data_text:
    "أُقرّ أنا المستخدم بأن جميع المعلومات والبيانات المدخلة أثناء عملية التسجيل صحيحة وكاملة وتعود لي شخصيًا، وأتحمّل المسؤولية القانونية الكاملة عن أي بيانات غير صحيحة أو مزيفة.",
  accept_terms_text:
    "أُقرّ بأنني قد اطلعت على كافة الشروط والأحكام المنظمة لاستخدام المنصة، وقبلت بها بشكل نهائي وملزم، ويُعد هذا الإقرار بمثابة قبول قانوني لا يحق معه الاعتراض لاحقًا.",

  // buttons
  prev: "السابق",
  next: "التالي",
  save: "حفظ",

  // otp
  verify_account: "التحقق من الحساب",
  otp_sent_to: "تم إرسال رمز تحقق مكوّن من 6 أرقام إلى",
  verify_wrong_email: "البريد غير صحيح؟",
  verify_back_to_register: "إعادة التسجيل",
  verify_back_to_login: "العودة لتسجيل الدخول",
  verify_session_expired: "انتهت صلاحية جلسة التحقق. يرجى التسجيل مرة أخرى.",
  verify_session_expired_login: "انتهت صلاحية جلسة التحقق. يرجى تسجيل الدخول مرة أخرى.",
  verify_code_expires_in: "ينتهي الرمز خلال",
  verify_code_expired: "انتهت صلاحية رمز التحقق. أعد إرسال رمز جديد.",
  confirm: "تأكيد",
  resend: "إعادة الإرسال",
  verified_success: "تم التحقق بنجاح ",
  deleted_success: "تم الحذف بنجاح ",

  // steps titles used in edited page
  step_consultant_info: "معلومات المستشار",
  consultant_info: "معلومات المستشار",
  consultant_info_hint: "بيانات مهنية لإنشاء ملف المستشار الخاص بك.",
  step_consultant_profile: "بيانات المستشار",

  // step 1 labels + placeholders
  consultant_name_label: "الاسم",
  consultant_name_ph: "مثال: مكتب خبراء الاستشارات",

  consultant_license_label: "رقم الرخصة",
  consultant_license_ph: "مثال: 123456",

  consultant_person_label: "اسم المستشار",
  consultant_person_ph: "مثال: أحمد العتيبي",

  // password field
  password: "الرقم السري",
  password_ph: "••••••••",

  // step 4 (qualifications)
  degree: "المؤهلات العلمية",
  degree_ph: "مثال: ماجستير إدارة أعمال",

  specialization: "التخصص",
  specialization_ph: "مثال: إدارة مشاريع",

  certificate_attach: "مرفق الشهادة",

  documents_attach: "مرفقات الوثائق",
  attach: "مرفق",
  attach_title: "عنوان",
  attach_title_ph: "كتابة عنوان مرفق",

  add_attach: "إضافة مرفق",
  org_name_ph_office: "مثال: مكتب الاستشارات المتقدّم",
  activity_ph_business: "مثال: استشارات أعمال",
  official_email_ph_office: "name@office.sa",

  cr_attachment_label: "مرفق السجل",
  org_attachment_label: "المرفق",
  unified_attachment_label: "المرفق",

  tax_no_ph: "مثال: 300123456700003",
  license_no_label: "رقم الرخصة",
  license_no_ph: "مثال: 1234567890",
  cr_no_ph: "مثال: 1010123456",
  step_establishment_info: "معلومات المنشأة",
  step_consulting_office_info: "بيانات مكتب الاستشارات",
  password_confirm: "تأكيد الرقم السري",
  password_confirm_ph: "••••••••",
  user_name: "اسم المستخدم",
  user_name_ph: "مثال: user123",

  office_change: "تغيير",
  office_remove: "إزالة",
  office_no_file: "لا يوجد ملف",

  office_selected_uploads: "الملفات المختارة",
  office_fetch_failed: "فشل تحميل بيانات المكتب",
  office_saved_failed: "فشل حفظ بيانات المكتب، حاول مرة أخرى",

  office_upload_placeholder_logo: "اختر ملف الشعار",
  office_upload_placeholder_letterhead: "اختر ملف الترويسة",
  office_upload_placeholder_unified_doc: "اختر مستند الرقم الموحّد",
  office_upload_placeholder_establishment_doc: "اختر مستند المنشأة",
  office_upload_placeholder_registration_doc: "اختر مستند السجل التجاري",

  section_about_consultant: "بيانات المستشار",
  field_consultant_name: "اسم المستشار",
  field_license_number: "رقم الترخيص",
  field_type: "النوع",
  field_specialization: "التخصص",
  field_qualification: "المؤهل",
  role_consultant: "مستشار",
  role_client: "عميل",
  role_consultant_office: "مكتب استشاري",

  account_field_qualification: "المؤهل العلمي",
  account_field_attachments: "إضافة مرفقات جديدة",
  account_field_qualification_placeholder: "أدخل مؤهلك العلمي",
  account_field_attachments_hint:
    "الملفات الحالية تظهر بالأعلى (باللون الرمادي)، والملفات الجديدة التي تختارها ستظهر باللون الأزرق.",
  account_field_attachments_placeholder: "اختر ملفات للرفع",

  accept_data_required: "يرجى الموافقة على صحة البيانات.",
  accept_terms_required: "يرجى الموافقة على الشروط والأحكام.",
  account_field_activity_description: "وصف النشاط",
  contact_error_validation: "تحقق من الحقول المطلوبة",
  contact_error_generic: "حدث خطأ، حاول مرة أخرى",
  attachments_hint: "الملفات التي شاركها العميل مع الطلب.",
  offer_hint: "يشمل أتعاب الاستشارة والضريبة.",
  client_info: "معلومات العميل",
  client_info_hint: "تفاصيل صاحب الطلب.",
  client_name: "الاسم",
  client_company: "الشركة",
  client_email: "البريد الإلكتروني",
  client_phone: "رقم الجوال",
  client_location: "الموقع",

  contact_method_hint: "كيفية إجراء الاستشارة.",
  consultant_response_hint: "سيظهر هنا ردّك أو ملاحظاتك المكتوبة للعميل.",
  view_response_hint: "عرض رد المستشار.",
  write_response: "كتابة الرد",
  consult_all_title: "جميع الاستشارات",
  consult_all_subtitle: "عرض وإدارة جميع الاستشارات في النظام",
  consult_all_search_placeholder: "ابحث بالرقم أو العنوان أو الوصف...",
  consult_filter_owner_all: "كل المستخدمين",
  consult_offer_hint: "حدد سعر عرضك وتفاصيل الموعد، ثم أرسله للعميل.",
  send_offer: "إرسال العرض",
  offer_sent_success: "تم ارسال العرض بنجاح",
  accepted_success: "تم القبول بنجاح",
  rejected_success: "تم الرفض بنجاح",
  write_your_response: "اكتب الرد",
  response_sent_success: "تم إرسال الرد بنجاح.",
  consult_method_none_desc: "لا أحتاج إلى تواصل الآن.",
  files_selected: "ملفات مختارة",
  click_to_change_files: "اضغط لتغيير الملفات",
  Construction: "مقاولات",

  chat_title: "المحادثة",
  consultation_chat_subtitle: "محادثة مرتبطة بهذه الاستشارة",
  payment_required_chat: "يلزم الدفع للوصول إلى المحادثة.",
  negotiate: "تفاوض",
  view_negotiation: "عرض التفاوض",
  negotiation_title: "التفاوض",
  negotiation_subtitle: "التفاوض على شروط الاستشارة",
  negotiation_window_title: "نافذة التفاوض المالي",
  current_offer: "العرض الحالي",
  negotiate_offer: "تعديل / عرض",
  accept_price: "قبول السعر",
  negotiation_your_offer: "عرضك",
  negotiation_form_hint: "السعر والملاحظة يُرسلان معاً",
  negotiation_your_turn: "حان دورك — أرسل عرضك للمتابعة.",
  negotiation_make_offer: "تقديم عرض",
  negotiation_counter_offer: "إرسال عرض مقابل",
  negotiation_offer_modal_subtitle:
    "أدخل المبلغ وملاحظة اختيارية، ويتم إرسالهما معاً.",
  negotiation_latest_other_offer: "آخر عرض من الطرف الآخر",
  negotiation_last_price: "آخر سعر مطروح",
  negotiation_history: "سجل التفاوض المالي",
  negotiation_round_of: "الجولة",
  negotiation_limit_note:
    "سعر عرضك الافتتاحي يُحتسب المحاولة الأولى من 3 محاولات متاحة لك كمستشار. بعد استنفاذها لا يمكنك تقديم أي عرض آخر.",
  negotiation_limit_modal_note:
    "تذكير: عرضك الافتتاحي هو المحاولة 1 من 3 لك كمستشار، ولا يُحتسب من محاولات العميل.",
  negotiation_limit_note_client:
    "يمكنك تقديم 3 عروض تفاوض فقط. بعد استنفاذها لا يمكنك تقديم أي عرض آخر.",
  negotiation_limit_modal_note_client:
    "تذكير: لديك 3 محاولات تفاوض فقط.",
  negotiation_client_turn: "دور العميل",
  negotiation_consultant_turn: "دور المستشار",
  negotiation_final_round_warning_consultant:
    "هذه هي جولتك الأخيرة المسموحة — بعدها يجب عليك القبول أو الرفض ، ولا يمكن تقديم عروض إضافية.",
  negotiation_final_round_warning_client:
    "هذه هي جولتك الأخيرة المسموحة، ولا يمكن تقديم عروض إضافية.",
  negotiation_last_offer: "إرسال العرض النهائي",
  negotiation_max_offers_hint:
    "تم بلوغ الحد الأقصى للعروض. يرجى قبول أو رفض آخر عرض.",
  negotiation_accept_hint: "قبول آخر عرض من الطرف الآخر",
  negotiation_accept_no_note: "لا توجد ملاحظة شروط مرفقة بهذا العرض.",
  negotiation_note_label: "ملاحظة / تفاصيل",
  optional: "اختياري",
  negotiation_empty: "لا توجد مفاوضات بعد.",
  negotiation_load_failed: "فشل تحميل المفاوضات.",
  negotiation_offer_failed: "فشل إرسال العرض.",
  negotiation_accept_failed: "فشل قبول السعر.",
  negotiation_offer_success: "تم إرسال العرض بنجاح.",
  negotiation_accept_success: "تم قبول السعر بنجاح.",
  negotiation_reject_consultation: "رفض الاستشارة",
  negotiation_reject_hint: "إذا كان العرض غير مناسب لك، يمكنك رفض الاستشارة.",
  negotiation_reject_confirm:
    "هل أنت متأكد من رفض هذه الاستشارة؟ سيتم إغلاق التفاوض ولا يمكن إعادة فتحه.",
  negotiation_reject_success: "تم رفض الاستشارة.",
  negotiation_reject_failed: "فشل رفض الاستشارة.",
  negotiation_rejected: "تم رفض الاستشارة. التفاوض مغلق.",
  negotiation_agreed: "تم الاتفاق على",
  negotiation_closed: "التفاوض مغلق",
  negotiation_agreed_on: "تم الاتفاق على عرض",
  negotiation_waiting_other: "تم إرسال عرضك. بانتظار رد الطرف الآخر.",
  negotiation_price_sent: "المبلغ المُرسل (شامل الضريبة)",
  negotiation_tax_added_hint: "ستُضاف الضريبة ويُرسل الإجمالي للعميل.",
  negotiation_amount_required: "يرجى إدخال مبلغ صالح.",
  negotiation_amount_placeholder: "المبلغ",
  negotiation_note_placeholder: "ملاحظة / تفاصيل الاستشارة (اختياري)",
  currency_sar: "ريال",
  back: "رجوع",
  conversation: "المحادثة",
  loading: "جاري التحميل...",
  no_messages: "لا توجد رسائل بعد.",
  you: "أنت",
  other: "الطرف الآخر",
  type_message: "اكتب رسالة...",
  chat_load_failed: "فشل تحميل المحادثة.",
  chat_send_failed: "فشل إرسال الرسالة.",
  consult_open_chat: "فتح المحادثة",
  consult_method_link: "الرابط",

  required: "هذا الحقل مطلوب",
  validation_required: "هذا الحقل مطلوب",
  validation_invalid: "قيمة غير صحيحة",
  validation_url: "الرابط غير صحيح",
  validation_date: "التاريخ غير صحيح",
  validation_time: "الوقت غير صحيح",
  please_fix_errors: "رجاءً صحّح الأخطاء الموضحة",
  enter_to_send_hint: "اضغط Enter للإرسال • Shift + Enter لسطر جديد",

  payment_method: "طريقة الدفع",
  payment_method_hint: "اختر الطريقة التي تود الدفع بها.",
  bank_transfer: "تحويل بنكي",
  cash: "نقدًا",
  choose_account: "اختر الحساب",
  no_bank_accounts: "لا توجد حسابات بنكية",
  save_payment: "حفظ الدفع",
  loading: "جاري التحميل...",
  processing: "جارٍ المعالجة...",
  payment_saved: "تم حفظ الدفع بنجاح",
  payment_error: "حدث خطأ أثناء حفظ الدفع",
  choose_payment_data: "يرجى اختيار بيانات الدفع",
  bank_account: "الحساب البنكي",
  open_invoices: "عرض الفواتير",

  invoice: "فاتورة",
  payment_details: "تفاصيل الدفع",
  consult_table_number: "الرقم",
  consult_table_date: "التاريخ",
  offer_before_tax: "قبل الضريبة",
  tax_percent: "نسبة الضريبة",
  tax_amount: "قيمة الضريبة",
  total_amount: "الإجمالي",
  payment_method: "طريقة الدفع",
  bank_transfer: "تحويل بنكي",
  pending: "قيد الانتظار",
  account_number: "رقم الحساب",
  confirm_and_accept: "تأكيد وقبول",
  close: "إغلاق",
  remove: "إزالة",

  account_identifier: "معرّف الحساب",
  transaction_reference: "الرقم المرجعي للتحويل",
  payment_image: "صورة إثبات الدفع",

  upload_image: "رفع صورة",
  upload_image_hint: "PNG, JPG حتى ميجابايت ",
  choose_file: "اختر ملف",
  change_file: "تغيير الملف",
  max_file_size: "الحد الأقصى 1MB",

  account_identifier_required: "معرّف الحساب مطلوب",
  account_identifier_invalid: "معرّف الحساب يجب أن يكون أرقامًا فقط",
  transaction_reference_required: "الرقم المرجعي للتحويل مطلوب",
  payment_image_required: "صورة إثبات الدفع مطلوبة",
  please_check_required_fields: "يرجى التحقق من الحقول المطلوبة",
  transaction_reference_invalid: "الرقم المرجعي غير صالح",
  choose_account_required: "يرجى اختيار حساب بنكي",
  invalid_file_type: "نوع الملف غير صالح",
  file_too_large: "حجم الملف كبير جدًا",
  invoice_not_found: "لم يتم العثور على فاتورة لهذه الاستشارة.",
  payment_saved_success: "تم حفظ الدفع بنجاح ",

  sidebar_item_my_invoices: "فواتيري",
  my_invoices: "فواتيري",
  my_invoices_hint: "تابع فواتيرك وحالة الدفع.",
  no_invoices: "لا توجد فواتير.",
  search_by_invoice_or_consultation: "بحث برقم الفاتورة أو رقم الاستشارة",
  view_payment_image: "عرض صورة التحويل",
  search: "بحث...",
  invoices: "الفواتير",
  paid: "مدفوعة",
  all: "الكل",
  refresh: "تحديث",
  pay: " دفع",
  consult_table_owner: "المستخدم",
  selected_file: "الملف المختار",
  accept_confirm_text:
    "هل أنت متأكد أنك تريد قبول هذا العرض؟ بعد القبول ستتمكن من المتابعة وإتمام الإجراءات اللازمة.",
  confirm_accept: "تأكيد القبول",
  account_identifier_placeholder: "أدخل رقم الحساب أو رقم التعريف",
  transaction_reference_placeholder: "أدخل رقم مرجع العملية (مثل SA0380...)",

  org_name_required: "اسم الجهة مطلوب",
  office_name_required: "اسم المكتب مطلوب",
  activity_required: "النشاط مطلوب",
  manager_required: "اسم المدير مطلوب",
  user_name_required: "اسم المستخدم مطلوب",
  client_type_required: "نوع العميل مطلوب",
  email_required: "البريد الإلكتروني مطلوب",
  invalid_email: "البريد الإلكتروني غير صحيح",
  phone_required: "رقم الجوال مطلوب",
  simple_description_required: "الوصف المختصر مطلوب",
  password_required: "كلمة المرور مطلوبة",
  password_min_8: "كلمة المرور يجب أن تكون 8 أحرف على الأقل",
  password_confirm_required: "تأكيد كلمة المرور مطلوب",
  password_not_match: "تأكيد كلمة المرور غير مطابق",

  city_required: "المدينة مطلوبة",
  district_required: "الحي مطلوب",
  street_required: "الشارع مطلوب",
  building_no_required: "رقم المبنى مطلوب",
  extra_no_required: "الرقم الإضافي مطلوب",
  zip_required: "الرمز البريدي مطلوب",
  short_address_required: "العنوان المختصر مطلوب",

  bank_owner_required: "اسم صاحب الحساب مطلوب",
  bank_account_required: "رقم الحساب مطلوب",
  bank_name_required: "اسم البنك مطلوب",

  consultant_name_required: "اسم الجهة/المستشار مطلوب",
  license_required: "رقم الترخيص مطلوب",
  consultant_person_required: "اسم المستشار (الشخص) مطلوب",
  region_required: "المنطقة مطلوبة",
  tax_no_required: "الرقم الضريبي مطلوب",
  degree_required: "المؤهل العلمي مطلوب",
  specialization_required: "التخصص مطلوب",

  certificate_required: "شهادة المؤهل مطلوبة",
  attachments_required: "يرجى إرفاق ملف واحد على الأقل",
  attach_title_required: "عنوان المرفق مطلوب",
  license_already_used: "رقم الترخيص مستخدم مسبقًا.",

  accept_data_required: "يرجى الموافقة على سياسة البيانات",
  accept_terms_required: "يرجى الموافقة على الشروط والأحكام",
  please_check_required: "يرجى التأكد من تعبئة الحقول المطلوبة.",
  register_success: "تم التسجيل بنجاح.",

  rejected: "مرفوض",
  consultation_rejected_msg: "تم رفض العرض",
  reject_popup_hint: "هل أنت متأكد من أنك تريد رفض هذا العرض؟",
  confirm_reject: "تأكيد الرفض",

  payment_status: "حالة الدفع",
  payment_paid: "مدفوعة",
  payment_under_review: "قيد المراجعة",
  payment_unpaid: "غير مدفوعة",
  payment_rejected: "مرفوضة",
  payment_unknown: "غير معروف",
  payment_status: "حالة الدفع",
  payment_status_paid: "مدفوعة",
  payment_status_under_review: "قيد المراجعة",
  payment_status_unpaid: "غير مدفوعة",
  payment_status_rejected: "مرفوضة",
  payment_status_pending: "بانتظار الدفع",
  payment_status_not_required: "غير مطلوب بعد",
  payment_status_unknown: "غير معروف",
  account_tab_account: "الحساب",
  account_tab_security: "الأمان",
  account_last_updated_hint: "آخر تحديث",

  consultant_section_profile: "بيانات الاستشاري",
  consultant_field_name: "الاسم",
  consultant_field_specialization: "التخصص",
  consultant_field_license_number: "رقم الترخيص",
  consultant_field_qualification: "المؤهل",
  consultant_field_image: "صورة الملف الشخصي",

  payment_status: "حالة الدفع",
  payment_status_paid: "مدفوعة",
  payment_status_under_review: "تحت المراجعة",
  payment_status_unpaid: "غير مدفوعة",
  payment_status_rejected: "مرفوضة",
  payment_status_pending: "بانتظار الدفع",
  payment_status_not_required: "غير مطلوب حالياً",
  payment_status_unknown: "غير محدد",

  consultant_settings_title: "إعدادات المستشار",
  consultant_settings_subtitle: "قم بتحديث ملفك الشخصي كمستشار.",

  choose_files: "اختر ملفات",
  no_file_chosen: "لم يتم اختيار ملف",

  consultant_section_more: "معلومات إضافية",
  consultant_field_type: "نوع الاستشاري",
  consultant_field_current_logo: "الشعار الحالي",
  consultant_section_address: "العنوان",

  address_city: "المدينة",
  address_district: "الحي",
  address_street: "الشارع",
  address_building: "رقم المبنى",
  address_additional: "الرقم الإضافي",
  address_postal: "الرمز البريدي",
  address_short: "العنوان المختصر",

  consultant_section_bank: "الحساب البنكي",
  bank_holder: "اسم صاحب الحساب",
  bank_iban: "الآيبان / رقم الحساب",

  consultant_section_attachments: "المرفقات",
  consultant_existing_attachments: "المرفقات الحالية",
  consultant_new_attachments: "إضافة مرفقات جديدة",

  file_hint_image: "PNG, JPG حتى ~5MB",
  file_hint_attachments: "صور أو PDF",

  office_name: "اسم المكتب",
  office_name_ph: "أدخل اسم المكتب",
  Dashboard: "لوحة التحكم",
  payment_under_review_title: "الدفع قيد المراجعة",
  payment_under_review_desc:
    "عملية الدفع قيد المراجعة حالياً. بعد اعتمادها ستظهر ردود المستشار هنا.",
  filters: "الفلاتر",
  apply: "تطبيق",
  consult_new: "جديدة",
  consult_finished: "مكتملة",
  reset: "إعادة تعيين",

  // ==== العامة / التخطيط ====
  register_title_client: "تسجيل حساب جديد",
  register_subtitle_fast: "اختر نوع الحساب ثم أكمل خطوات التسجيل المبسطة.",
  register_badge: "تسجيل جديد",
  register_secure: "عملية آمنة",
  register_fast_hint: "تسجيل مبسط بخطوات واضحة.",
  selected: "النوع المحدد",
  register_note_verify: "قد يتطلب تفعيل حسابك إجراء تحقق أولي.",

  // ==== نوع المستخدم (أعلى النموذج) ====
  user_type: "نوع المستخدم",
  user_type_title: "اختر نوع الحساب",
  user_type_hint: "اختر الخيار الأنسب لوضعك، وسيتم تكييف النموذج تلقائيًا.",

  type_client: "عميل",
  type_consultant: "مستشار",
  type_office: "مكتب استشاري",

  type_client_desc: "منشآت أو أفراد يبحثون عن خدمات استشارية.",
  type_consultant_desc: "خبراء مستقلون يقدمون خدمات واستشارات تخصصية.",
  type_office_desc: "مكاتب أو شركات استشارية تضم فريق عمل متكامل.",

  // ==== الخطوات (الستبر) ====
  step_client_info: "بيانات العميل",
  step_account_info: "بيانات الحساب",
  office_info: "بيانات المكتب",
  office_info_hint: "بيانات المكتب اللازمة لإعداد ملف مكتب الاستشارات.",
  account_info: "بيانات الحساب",
  account_info_hint: "تفاصيل تسجيل الدخول وبيانات التواصل لهذا الحساب.",
  step_declarations: "الإقرارات",

  prev: "السابق",
  next: "التالي",

  // ==== قسم بيانات العميل ====
  client_section: "بيانات الجهة",
  client_section_hint: "أخبرنا عن منشأتك أو مشروعك.",

  org_name: "اسم المنشأة",
  org_name_ph: "أدخل اسم المنشأة",
  manager_name: "اسم المسؤول / المدير",
  manager_name_ph: "أدخل اسم المسؤول",
  activity: "النشاط الرئيسي",
  activity_ph: "صف النشاط الرئيسي باختصار",
  client_type: "نوع العميل",
  choose: "اختر",
  choose_client_type: "نوع العميل اختر",
  choose_client_type_hint: "اختر الفئة الأقرب لطبيعة مشروعك.",
  simple_description: "وصف مختصر",
  simple_description_hint: " لمحة سريعة عن نشاطك.",
  simple_description_ph: "اكتب وصفًا مختصرًا لنشاطك",

  // ==== قسم بيانات المستخدم ====
  user_section: "بيانات المستخدم",
  user_section_hint: "معلومات الدخول الخاصة بك.",

  user_name: "اسم المستخدم",
  user_name_ph: "أدخل اسمك الكامل",
  official_email_label: "البريد الإلكتروني الرسمي",
  official_email_ph: "name@example.com",
  mobile: "رقم الجوال",
  mobile_ph: "05xxxxxxxx",
  password: "كلمة المرور",
  password_ph: "أدخل كلمة مرور قوية",
  password_confirm: "تأكيد كلمة المرور",
  password_confirm_ph: "أعد إدخال كلمة المرور",

  // ==== الإقرارات ====
  declarations: "الإقرارات",
  declarations_hint: "يرجى مراجعة الإقرارات التالية والموافقة عليها.",

  accept_data_text: "أوافق على جمع ومعالجة بياناتي وفقًا لسياسة الخصوصية.",
  accept_terms_text: "اطلعت على الشروط والأحكام وأوافق عليها.",
  accept_terms_prefix: "اطلعت على",
  terms_and_policy: "الشروط والأحكام",
  accept_terms_suffix: "وأوافق عليها.",

  // ==== الأزرار / الرسائل ====
  save: "إنشاء الحساب",
  saving: "جاري إنشاء الحساب...",
  go_to_login: "العودة لتسجيل الدخول",

  // ==== رسائل التحقق ====
  org_name_required: "اسم المنشأة مطلوب.",
  activity_required: "النشاط مطلوب.",
  manager_required: "اسم المسؤول مطلوب.",
  client_type_required: "نوع العميل مطلوب.",
  user_name_required: "اسم المستخدم مطلوب.",
  email_required: "البريد الإلكتروني مطلوب.",
  phone_required: "رقم الجوال مطلوب.",
  invalid_phone: "رقم الجوال غير صحيح.",
  password_required: "كلمة المرور مطلوبة.",
  password_confirm_required: "تأكيد كلمة المرور مطلوب.",
  password_not_match: "كلمتا المرور غير متطابقتين.",
  accept_data_required: "يجب الموافقة على سياسة البيانات.",
  accept_terms_required: "يجب الموافقة على الشروط والأحكام.",
  please_check_required: "يرجى التحقق من الحقول المطلوبة.",
  register_success: "تم إنشاء الحساب بنجاح.",
  consultant_dashboard: {
    // ===== لوحة المستشار (جديد) =====
    summary_title: "ملخص لوحة المستشار",
    updating: "جاري التحديث...",
    year: "السنة: {year}",
    sections: {
      consultations: "الاستشارات",
      revenue: "الدفعات والإيرادات",
      expenses: "المصروفات",

    },


    consultations: {
      // الاستشارات
      total: "إجمالي الاستشارات",
      money: {
        card_title_revenue: "الإيرادات",
        card_desc_revenue: "المستلم والمتبقي (للاستشاري)",
        card_title_expenses: "النفقات",
        card_desc_expenses: "المدفوع والمستحق ",

        paid_after_tax: "مدفوع (بعد استقطاع الضريبة)",
        unpaid_before_tax: "غير مدفوع (قبل  استقطاع الضريبة)",

        paid_expenses: "نفقات مدفوعة",
        unpaid_expenses: "نفقات غير مدفوعة",

        pill_received: "مستلم",
        pill_pending: "متبقي",
        pill_paid: "مدفوع",
        pill_due: "مستحق",

        note_tax: "ملاحظة: يتم عرض المدفوع بعد إضافة ضريبة القيمة المضافة (15%)، بينما غير المدفوع قبل الضريبة.",
      },
      status: {
        new: "جديدة",
        accepted: "مقبولة",
        under_study: "تحت الدراسة",
        finished: "مكتملة",
      },
      methods: {
        sessions_chats: "جلسات / محادثات",
      }



    }


    ,
    payments: {
      paid: "مدفوعة",
      unpaid: "غير مدفوعة",
      under_review: "قيد المراجعة",
      rejected: "مرفوضة",
      failed: "فشلت",
      cancelled: "ملغاة",
    },
    // الدفعات

    revenue: {
      // الإيرادات
      paid_total: "إجمالي المدفوع",
      unpaid_total: "إجمالي غير المدفوع",
      under_review_total: "إجمالي قيد المراجعة",
    }

  }
  ,
  // ===== Dashboard – Consultations Chart =====
  dashboard_consultations_overview_title: "نظرة عامة على الاستشارات",
  dashboard_consultations_overview_subtitle: "توزيع الاستشارات الشهرية",

  dashboard_consultations_series_live_chat: "دردشة",
  dashboard_consultations_series_sessions: "جلسات",
  dashboard_consultations_series_finished: "منتهية",

  dashboard_consultations_tooltip_count: "{count} استشارة",

  dashboard_year: "السنة: {year}",
  common_updating: "جارٍ التحديث…",

  // ===== Months =====
  month_jan: "يناير",
  month_feb: "فبراير",
  month_mar: "مارس",
  month_apr: "أبريل",
  month_may: "مايو",
  month_jun: "يونيو",
  month_jul: "يوليو",
  month_aug: "أغسطس",
  month_sep: "سبتمبر",
  month_oct: "أكتوبر",
  month_nov: "نوفمبر",
  month_dec: "ديسمبر",
  consultant_dashboard: {
    summary_title: "ملخص الأداء",
    year: "سنة {year}",

    sections: {
      consultations: "الاستشارات",
      payments_revenue: "المدفوعات والإيرادات",
    },

    consultations: {
      subtitle: "إحصائيات حالات الاستشارات وطرق تنفيذها",
      total: "إجمالي الاستشارات",
      status: {
        new: "جديدة",
        accepted: "مقبولة",
        under_study: "قيد الدراسة",
        finished: "منتهية",
      },
      methods: {
        sessions_chats: "جلسات / دردشة",
      },
    },

    revenue: {
      subtitle: "ملخص الإيرادات بحسب حالة الدفع",
      paid_total: "إجمالي المدفوع",
      unpaid_total: "إجمالي غير المدفوع",
    },
    money: {
      card_title_revenue: "الإيرادات",
      card_desc_revenue: "الأموال المستلمة والمعلقة  (للاستشاري)",
      card_title_expenses: "المصروفات",
      card_desc_expenses: "المبالغ المدفوعة والمستحقة",

      paid_after_tax: "مدفوع (بعد استقطاع الضريبة)",
      unpaid_before_tax: "غير مدفوع (قبل استقطاع الضريبة)",
      unpaid_after_tax: "غير مدفوع (قبل استقطاع الضريبة)",

      paid_expenses: "المصروفات المدفوعة",
      unpaid_expenses: "المصروفات غير المدفوعة",

      pill_received: "مستلم",
      pill_pending: "معلق",
      pill_paid: "مدفوع",
      pill_due: "مستحق",

      note_tax: "ملاحظة: يتم عرض المدفوع وغير المدفوع  بعد إضافة ضريبة القيمة المضافة (15%).",
    },
  },

  common: {
    updating: "جاري التحديث...",
    updated: "تم التحديث",
    paid: "مدفوع",
    unpaid: "غير مدفوع",
  },
  legal: {
    last_updated: "آخر تحديث: {date}",
    read_time: "مدة القراءة: {min} دقائق",

    privacy: {
      badge: "الخصوصية",
      title: "سياسة الخصوصية",
      subtitle:
        "توضح هذه السياسة كيفية جمع واستخدام وحماية بياناتك عند استخدام خدمات الاستشارات الذكية.",

      sections: {
        intro: {
          title: "نظرة عامة",
          body:
            "نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية عبر ضوابط واضحة ومعالجة مسؤولة.",
        },

        data_we_collect: {
          title: "البيانات التي نجمعها",
          b1: "بيانات الحساب (الاسم، البريد/الجوال، الدور).",
          b2: "تفاصيل الاستشارات وما يرتبط بها من تواصل.",
          b3: "بيانات الفواتير والمدفوعات (عند الحاجة).",
          b4: "بيانات تقنية (الجهاز، السجلات، الكوكيز) لتحسين جودة الخدمة.",
        },

        how_we_use: {
          title: "كيف نستخدم بياناتك",
          b1: "لتقديم وإدارة الاستشارات والدعم.",
          b2: "لمعالجة المدفوعات وإصدار الفواتير عند الحاجة.",
          b3: "لتحسين أداء المنصة وتجربة المستخدم.",
          b4: "للالتزام بالمتطلبات النظامية والتنظيمية.",
        },

        sharing: {
          title: "المشاركة والإفصاح",
          b1: "لا نقوم ببيع بياناتك لأي طرف ثالث.",
          b2: "قد نشارك مع مزودي الخدمة (الاستضافة/الدفع) بالقدر اللازم لتقديم الخدمة فقط.",
          b3: "قد نفصح عند طلب الجهات المختصة أو لحماية الحقوق والسلامة.",
        },

        cookies: {
          title: "ملفات تعريف الارتباط (Cookies)",
          body:
            "نستخدم الكوكيز وتقنيات مشابهة لتذكر التفضيلات وتأمين الجلسات وفهم أنماط الاستخدام.",
        },

        rights: {
          title: "حقوقك",
          b1: "طلب الوصول إلى بياناتك الشخصية.",
          b2: "طلب تصحيح أو تحديث بياناتك.",
          b3: "طلب حذف البيانات عند السماح النظامي بذلك.",
          b4: "سحب الموافقة إذا كانت المعالجة مبنية على الموافقة.",
        },

        retention: {
          title: "مدة الاحتفاظ بالبيانات",
          body:
            "نحتفظ بالبيانات للمدة اللازمة لتقديم الخدمة والالتزامات النظامية، ثم نقوم بحذفها أو إخفاء هويتها بأمان.",
        },

        contact: {
          title: "التواصل",
          body:
            "للاستفسارات أو الطلبات المتعلقة بالخصوصية، تواصل معنا عبر قنوات الدعم المتاحة بالموقع.",
        },
      },
    },

    terms: {
      badge: "الشروط",
      title: "الشروط والأحكام",
      subtitle:
        "تنظم هذه الشروط استخدام منصة وخدمات الاستشارات الذكية. باستخدامك للخدمة فأنت توافق على هذه الشروط.",

      sections: {
        acceptance: {
          title: "الموافقة على الشروط",
          body:
            "بإنشاء حساب أو استخدام المنصة، فإنك توافق على الالتزام بهذه الشروط والسياسات ذات العلاقة.",
        },

        accounts: {
          title: "الحسابات والمسؤوليات",
          b1: "أنت مسؤول عن الحفاظ على سرية بيانات الدخول.",
          b2: "يلزم تقديم بيانات صحيحة وتحديثها عند التغيير.",
          b3: "قد يؤدي سوء الاستخدام أو الاحتيال إلى إيقاف الحساب.",
        },

        payments: {
          title: "المدفوعات",
          b1: "قد تختلف الرسوم وشروط الدفع حسب نوع الخدمة.",
          b2: "تظهر الفواتير وحالات الدفع في لوحة التحكم.",
          b3: "قد تُطبق الضرائب حسب نوع الخدمة والأنظمة.",
          b4: "تخضع الاستردادات والنزاعات لسياسة المنصة والأنظمة ذات العلاقة.",
        },

        cancellation: {
          title: "الإلغاء",
          body:
            "يمكن إلغاء بعض الخدمات وفق ضوابط الإلغاء الموضحة وقت الشراء أو الحجز.",
        },

        liability: {
          title: "حدود المسؤولية",
          body:
            "نقدم الخدمة كما هي، ولا نتحمل المسؤولية عن الأضرار غير المباشرة ضمن الحدود التي يسمح بها النظام.",
        },

        governing_law: {
          title: "القانون الحاكم",
          body:
            "تخضع هذه الشروط للأنظمة واللوائح المحلية السارية حيث تُقدَّم الخدمة.",
        },

        changes: {
          title: "تحديث الشروط",
          body:
            "قد نقوم بتحديث هذه الشروط من وقت لآخر. استمرار استخدامك للخدمة يعني موافقتك على النسخة المحدّثة.",
        },

        contact: {
          title: "التواصل",
          body:
            "للاستفسارات حول الشروط، يرجى التواصل عبر قنوات الدعم المتاحة بالموقع.",
        },
      },
    },

    consent: {
      terms: "اطلعت على الشروط والأحكام وأوافق عليها.",
      privacy: "أوافق على جمع ومعالجة بياناتي وفقًا لسياسة الخصوصية.",
    },
  },
  // ... existing keys
  privacy_intro_1: "في ",
  privacy_brand: "منصة الاستشارات الذكية",
  privacy_intro_2:
    "، نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية وفق القوانين المعمول بها. من خلال استخدامك لخدماتنا، فإنك توافق على بنود هذه السياسة.",

  privacy_s1_title: "1. المعلومات التي نقوم بجمعها",
  privacy_s1_item1_label: "معلومات شخصية:",
  privacy_s1_item1_text:
    " مثل الاسم، رقم الهاتف، البريد الإلكتروني، العنوان والبيانات البنكية.",

  privacy_s2_title: "2. كيفية استخدام المعلومات",
  privacy_s2_item1: "لتقديم الخدمات وتحسين تجربتك.",
  privacy_s2_item2: "لمعالجة الطلبات.",
  privacy_s2_item3: "للتواصل معك بشأن الطلبات أو التحديثات أو العروض.",
  privacy_s2_item4: "لتحليل البيانات وتحسين المنصة وأدائها.",

  privacy_s3_title: "3. مشاركة المعلومات",
  privacy_s3_item1: "لا نقوم ببيع أو تأجير بياناتك الشخصية لأي طرف ثالث.",
  privacy_s3_item2: "قد نكشف عن بياناتك إذا تطلب القانون ذلك أو لحماية حقوقنا القانونية.",

  privacy_s4_title: "4. ملفات تعريف الارتباط (Cookies)",
  privacy_s4_text:
    "نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح وتسهيل تسجيل الدخول وتتبع استخدام المنصة بشكل مجهول لتحليل الأداء.",

  privacy_s5_title: "5. حماية البيانات",
  privacy_s5_text:
    "نستخدم إجراءات تقنية وتنظيمية مناسبة لحماية بياناتك من الوصول أو الاستخدام غير المصرح به.",

  privacy_s6_title: "6. حقوقك",
  privacy_s6_item1: "يمكنك طلب الوصول إلى بياناتك الشخصية أو تعديلها أو حذفها عند الحاجة.",

  privacy_s7_title: "7. روابط خارجية",
  privacy_s7_text:
    "قد تحتوي منصتنا على روابط لمواقع خارجية، ولسنا مسؤولين عن سياسات الخصوصية الخاصة بهم.",

  privacy_s8_title: "8. تحديثات السياسة",
  privacy_s8_text:
    "قد نقوم بتحديث هذه السياسة من وقت لآخر، وسيتم نشر التحديثات على هذه الصفحة مع تعديل تاريخ التحديث.",

  privacy_s9_title: "9. التواصل معنا",
  privacy_s9_text:
    "لأي استفسار أو طلب بخصوص سياسة الخصوصية، يمكنك التواصل معنا عبر:",

  privacy_email_label: "البريد:",
  privacy_phone_label: "الهاتف:",
  privacy_updated_label: "تاريخ التحديث",
  privacy_updated_date: "1 / 2 / 2026",

  sidebar_group_tickets: "التذاكر",
  sidebar_item_my_tickets: "تذاكري",
  sidebar_item_create_ticket: "إنشاء تذكرة",

  ticket_my_title: "تذاكري",
  ticket_my_subtitle: "تتبع وإدارة تذاكر الدعم",
  ticket_create_title: "إنشاء تذكرة",
  ticket_create_subtitle: "صف المشكلة وسنتابع معك",
  ticket_create_form_section: "تفاصيل التذكرة",
  ticket_create_tips_title: "قبل الإرسال",
  ticket_create_tip_subject: "استخدم عنوانًا واضحًا لتسريع توجيه التذكرة.",
  ticket_create_tip_details: "اذكر الخطوات، رسائل الخطأ، وما كنت تتوقع حدوثه.",
  ticket_create_tip_files: "لقطات الشاشة أو المستندات تساعدنا على حل المشكلة أسرع.",
  ticket_detail_title: "تفاصيل التذكرة",
  ticket_search_placeholder: "رقم أو موضوع…",
  ticket_search_hint: "ابحث برقم التذكرة أو الموضوع.",
  ticket_filter_all: "الكل",
  ticket_filter_new: "جديد",
  ticket_filter_label: "تصفية حسب الحالة",
  ticket_filter_clear: "إزالة التصفية",
  ticket_filter_clear_all: "مسح الكل",
  ticket_filter_status: "الحالة",
  ticket_filter_search: "بحث",
  ticket_filter_active_hint: "نتائج مُصفّاة",
  ticket_results_count: "عرض",
  notifications_title: "الإشعارات",
  notifications_subtitle: "تحديثات التذاكر والاستشارات",
  notifications_empty: "لا توجد إشعارات جديدة",
  notifications_mark_all_read: "تعيين الكل كمقروء",
  notifications_view_all: "عرض كل الإشعارات",
  notifications_loading: "جاري التحميل…",
  notifications_tab_all: "الكل",
  notifications_tab_tickets: "التذاكر",
  notifications_tab_consultations: "الاستشارات",
  notifications_unread_label: "غير مقروء",
  notifications_all_read: "لا توجد إشعارات جديدة",
  notifications_empty_hint: "سنُعلمك عندما يكون هناك تحديث يحتاج انتباهك.",
  notifications_error: "تعذّر تحميل الإشعارات",
  notifications_retry: "إعادة المحاولة",
  notifications_total_label: "الإجمالي",
  notifications_refresh: "تحديث",
  notifications_filter_label: "تصفية الإشعارات",
  notifications_tab_negotiations: "المفاوضات",
  notifications_page_prev: "السابق",
  notifications_page_next: "التالي",
  ticket_table_number: "رقم التذكرة",
  ticket_table_type: "النوع",
  ticket_table_subject: "العنوان",
  ticket_table_status: "الحالة",
  ticket_table_party: "الجهة",
  ticket_table_updated: "آخر تحديث",
  ticket_table_actions: "الإجراءات",
  ticket_table_empty: "لا توجد تذاكر حالياً.",
  ticket_table_empty_filtered: "لا توجد تذاكر تطابق الفلاتر المحددة.",
  ticket_table_empty_hint: "أنشئ تذكرة عندما تحتاج مساعدة من فريقنا.",
  ticket_load_failed: "فشل تحميل التذاكر.",
  ticket_create_success: "تم إنشاء التذكرة بنجاح.",
  ticket_create_failed: "فشل إنشاء التذكرة.",
  ticket_subject: "العنوان",
  ticket_subject_placeholder: "ملخص مختصر للمشكلة",
  ticket_description: "الوصف",
  ticket_description_placeholder: "اشرح المشكلة بالتفصيل",
  ticket_priority: "الأولوية",
  ticket_category: "التصنيف",
  ticket_category_none: "بدون تصنيف",
  ticket_attachments: "المرفقات",
  ticket_attachments_hint: "حتى 5 ملفات، 10MB (صور، PDF، Office)",
  ticket_sla_hint: "الرد المتوقع خلال",
  ticket_hours: "ساعات",
  ticket_submit_create: "إرسال التذكرة",
  ticket_copy_number: "نسخ رقم التذكرة",
  ticket_status_new: "جديد",
  ticket_status_unknown: "غير معروف",
  ticket_timeline: "سجل الأحداث",
  ticket_timeline_empty: "لا توجد أحداث بعد.",
  ticket_load_more: "تحميل المزيد",
  ticket_comments: "التعليقات",
  ticket_comments_empty: "لا توجد تعليقات بعد.",
  ticket_comments_empty_hint: "أضف تعليقك أو مرفقات في النموذج أدناه",
  ticket_comment_placeholder: "اكتب رسالتك…",
  ticket_comment_submit: "إرسال التعليق",
  ticket_comment_success: "تم إضافة التعليق.",
  ticket_comment_failed: "فشل إضافة التعليق.",
  ticket_reopen: "إعادة فتح",
  ticket_escalate: "تصعيد",
  ticket_close: "إغلاق التذكرة",
  ticket_reopen_hint: "عادت المشكلة — إعادة فتح لخدمة العملاء",
  ticket_escalate_hint: "غير راضٍ عن الحل — تصعيد للإدارة",
  ticket_close_hint: "تم قبول الحل — إغلاق التذكرة نهائيًا",
  ticket_close_confirm:
    "بالتأكيد أنت تقبل الحل المقدَّم وسيتم إغلاق التذكرة. هل تريد المتابعة؟",
  ticket_reopen_success: "تم إعادة فتح التذكرة.",
  ticket_escalate_success: "تم تصعيد التذكرة.",
  ticket_close_success: "تم إغلاق التذكرة.",
  ticket_action_failed: "فشل تنفيذ الإجراء.",
  ticket_note_optional: "ملاحظة (اختياري)",
  ticket_requester: "مقدم الطلب",
  ticket_no_attachments: "لا توجد مرفقات",
  ticket_view: "عرض",
  ticket_back_list: "العودة ",
  ticket_not_found: "التذكرة غير موجودة.",
  ticket_overdue: "متأخرة",
  ticket_create_cta: "تذكرة جديدة",
  ticket_tab_discussion: "المحادثة",
  ticket_tab_activity: "سجل الأحداث",
  ticket_created_at: "تاريخ الإنشاء",
  ticket_dropzone_title: "اسحب الملفات هنا أو انقر للاختيار",
  ticket_comment_yours: "تعليقاتك",
  ticket_comment_others: "الفريق والآخرين",
  ticket_comment_creator: "مقدّم التذكرة",
  ticket_comment_handler: "مسؤول التذكرة",
  ticket_support_team: "فريق الدعم",
  ticket_actor_system: "النظام",
  ticket_detail_subtitle: "متابعة تفاصيل التذكرة والردود عليها",
  ticket_summary: "ملخص التذكرة",
  ticket_assigned_to: "مسؤول المعالجة",
  ticket_unassigned: "لم يتم الإسناد",
  ticket_comments_closed: "التعليقات مغلقة حالياً",
  ticket_comment_you: "أنت",
  ticket_comment_participants: "المشاركون",
  ticket_comments_sort_oldest: "الأقدم أولاً",
  ticket_comments_sort_newest: "الأحدث أولاً",
  ticket_comment_attachments_only: "مرفقات بدون نص",
  ticket_timeline_top: "الأعلى",
  ticket_show_more: "عرض المزيد",
  ticket_show_less: "إخفاء",
  ticket_today: "اليوم",
  ticket_yesterday: "أمس",
  ticket_event_latest: "الأحدث",
  ticket_event_comment: "تعليق جديد",
  ticket_event_create: "إنشاء التذكرة",
  ticket_event_reopen: "إعادة فتح",
  ticket_event_escalate: "تصعيد",
  ticket_event_resolve: "تم الحل",
  ticket_event_assign: "إسناد",
  ticket_event_transfer: "تحويل",
  ticket_event_close: "إغلاق",
  ticket_event_note: "ملاحظة",
  ticket_event_status: "تغيير الحالة",
};
